export default [
  'Abyssinian',
  'Abyssinian Mix',
  'Aegean cat',
  'American Bobtail',
  'American Curl',
  'American Longhair',
  'American Polydactyl',
  'American Shorthair',
  'American Wirehair',
  'Angora',
  'Angora Mix',
  'Arabian Mau',
  'Asian Leopard',
  'Asian Semi-longhair',
  'Australian Mist',
  'Balinese',
  'Balinese Mix',
  'Bambino',
  'Bengal',
  'Bengal Mix',
  'Birman',
  'Bobcat Mix',
  'Bombay',
  'Bombay Mix',
  'Brazilian Shorthair',
  'British Blue',
  'British Longhair',
  'British Shorthair',
  'Burmese',
  'Burmese Mix',
  'Burmilla',
  'California Spangled Cat',
  'Chantilly/Tiffany cat',
  'Chartreaux',
  'Chartreux',
  'Chausie',
  'Cheetah',
  'Chinchilla Cat',
  'Chinese Li Hua',
  'Colorpoint Shorthair',
  'Cornish Rex',
  'Cougar',
  'Cymric',
  'Cyprus',
  'Devon Rex',
  'Domestic Dwarf',
  'Domestic Long Hair (DLH)',
  'Domestic Medium Hair (DMH)',
  'Domestic Short Hair (DSH)',
  'Donskoy',
  'Egyptian Mau',
  'Egyptian Mau Mix',
  'Egyptian Shorthair',
  'European Shorthair',
  'Exotic',
  'Fishing Cat',
  'Foldex',
  'German Rex',
  'Havana Brown',
  'Highlander Cat',
  'Himalayan',
  'Himalayan Mix',
  'Ichabod',
  'Indonesian Wildcat',
  'Jaguar',
  'Japanese Bobtail',
  'Javanese',
  'Jungle Cat',
  'Khao Manee',
  'Korat',
  'Kurilian Bobtail',
  'LaPerm',
  'LaPerm Mix',
  'Lion',
  'Lykoi',
  'Lynx',
  'Maine Coon',
  'Maine Coon Mix',
  'Malayan',
  'Mandalay',
  'Manx',
  'Manx Mix',
  'Minskin',
  'Mokave Jag',
  'Munchkin',
  'Napoleon Cat',
  'Nebelung',
  'Norwegian Forest Cat',
  'Norwegian Forest Cat Mix',
  'Ocelot',
  'Ocicat',
  'Ojos Azules',
  'Oriental Longhair',
  'Oriental Shorthair',
  'Panther',
  'Persian',
  'Persian Mix',
  'Peterbald',
  'Pixie-Bob',
  'Pixie-Bob Mix',
  'Raas',
  'Ragamuffin',
  'Ragdoll',
  'Ragdoll Mix',
  'Rex Mix',
  'Russian',
  'Russian Blue',
  'Russian Blue Mix',
  'Sam Sawet',
  'Sand Cat',
  'Savannah',
  'Savannah Mix',
  'Scottish Fold',
  'Scottish Fold Mix',
  'Selkirk Rex',
  'Serengeti',
  'Serrade Petit',
  'Serval',
  'Siamese',
  'Siamese Mix',
  'Siberian',
  'Siberian Mix',
  'Siberian Tiger',
  'Singapura',
  'Snowshoe',
  'Snowshoe Mix',
  'Sokoke',
  'Somali',
  'Somali Mix',
  'Sphynx',
  'Sphynx Mix',
  'Suphalak',
  'Thai Cat',
  'Tiger',
  'Tonkinese',
  'Tonkinese Mix',
  'Toyger',
  'Turkish Angora',
  'Turkish Van',
  'Turkish Van Mix',
  'Ukrainian Levkoy',
  'Unknown',
  'York Chocolate',
]
